import ApiService from "@/core/services/api.service";
// action types
export const GET_CONVERSIONBANCOS = "getConversionBanco";

// mutation types
export const SET_CONVERSIONBANCOS = "setConversionBancos";


export const SET_ERROR = "setError";

const state = {
  errors: [],
  conversionBancos: [],

};

const actions = {
  [GET_CONVERSIONBANCOS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/ConversionBanco/v1/conversionBancos`}, '')
        .then(({ data }) => {
            console.log(JSON.stringify(data));
          context.commit(SET_CONVERSIONBANCOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_CONVERSIONBANCOS](state, data) {
    state.error = {};
    state.conversionBancos = data;
  },

};

export default {
  state,
  actions,
  mutations
};
